import AppShell from "../components/layout/AppShell";
import CustomerManagement from "../components/admin/CustomerManagement";

export default function AdminCustomers() {
  return (
    <AppShell wide title="Customers">
      <CustomerManagement />
    </AppShell>
  );
}
